<h1 mat-dialog-title>Comentarios y Preinforme</h1>
<div mat-dialog-content class="comment-div-scroll">
    <div [innerHTML]="comments"></div>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>